import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, computed, inject, input } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router, RouterModule } from "@angular/router";

import { NotificationType, ServiceType } from "../../../apis/networkdashboard/graphql/graphql";
import { HealthRecord } from "../../../apis/stats/rest/models";
import { ReadableSizePipe } from "../../../helpers/bitspipe/bitspipe";
import { phraseDetailPath } from "../../../pages/subscription-detail/subscription-detail-redirection";
import { AliasEditorComponent } from "../../common/alias-editor/alias-editor.component";
import { StatusIcon } from "../../common/status-icon/status-icon.component";
import { openDialogIncident } from "../../dialogs/dialog-incident/dialog-incident";
import { PortVisualiser } from "../../subscription-detail/port-visualiser/port-visualiser";
import { ServiceStatusComponent } from "../service-status/service-status";
import { ServiceSubtitleComponent } from "../service-subtitle/service-subtitle";
import { ServiceTags } from "../service-tags/service-tags";
import { ServiceElementViewData } from "./network-service-element.model";

@Component({
  selector: "network-service-element",
  templateUrl: "network-service-element.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AliasEditorComponent,
    AngularSvgIconModule,
    PortVisualiser,
    ReadableSizePipe,
    RouterModule,
    ServiceTags,
    ServiceStatusComponent,
    ServiceSubtitleComponent,
    StatusIcon,
    TranslatePipe,
  ],
})
export class NetworkServiceElement {
  private dialog: MatDialog = inject(MatDialog);
  private router = inject(Router);

  protected subscription = input.required<ServiceElementViewData>();
  protected health = input.required<HealthRecord>();
  protected serviceDisruption = input<NotificationType>();
  protected productType = computed(() => this.subscription().product.type);
  protected productTag = computed(() => this.subscription().product.tag);

  protected subscriptionId = computed(() => this.subscription().subscriptionId);
  protected customerDescription = computed(() => this.subscription().customerDescription);
  protected firewallEnabled = computed(() => this.subscription().firewallEnabled ?? false);
  protected tags = computed(() => this.subscription().tags);
  protected routerLink = computed(() => phraseDetailPath(this.productType(), this.productTag(), this.subscriptionId()));

  private isPort = computed(() => this.productType() === "Port");

  protected showPortVisualizer = computed(() => this.isPort() && this.subscription().portMode !== "link_member");

  protected navigateToService(service: ServiceType): void {
    this.router.navigate(phraseDetailPath(service.product.type, service.product.tag, service.subscriptionId));
  }

  openIncidentDialog(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    openDialogIncident(this.dialog, this.subscription());
    return false;
  }
}
